import React, { createContext, useContext, useState, ReactNode } from 'react';

interface FacebookTokenContextType {
  tokenVersion: number;
  incrementTokenVersion: () => void;
}

const FacebookTokenContext = createContext<FacebookTokenContextType | undefined>(undefined);

export const FacebookTokenProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [tokenVersion, setTokenVersion] = useState(0);
  const incrementTokenVersion = () => setTokenVersion((v) => v + 1);
  return (
    <FacebookTokenContext.Provider value={{ tokenVersion, incrementTokenVersion }}>
      {children}
    </FacebookTokenContext.Provider>
  );
};

export const useFacebookTokenContext = () => {
  const context = useContext(FacebookTokenContext);
  if (!context) throw new Error('useFacebookTokenContext must be used within a FacebookTokenProvider');
  return context;
};
